import React from 'react';

const TermsPage = () => {
  return (
    <div className="min-h-screen bg-gray-50 py-12">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="bg-white shadow-lg rounded-lg p-8">
          <h1 className="text-3xl font-bold text-gray-900 mb-8">
            Kullanım Koşulları
          </h1>
          
          <div className="prose prose-lg max-w-none">
            <h2 className="text-xl font-semibold mb-4">1. GENEL HÜKÜMLER</h2>
            <p className="mb-4">
              www.fielhome.com internet sitesi ("Site"), Fiel Home tarafından işletilmektedir. 
              Bu kullanım koşulları ("Koşullar"), sitemizi ziyaret eden ve kullanan 
              tüm kullanıcılar için geçerlidir.
            </p>
            
            <h3 className="text-lg font-semibold mb-3">1.1. Şirket Bilgileri</h3>
            <div className="bg-gray-100 p-4 rounded-lg mb-4">
              <p><strong>Unvan:</strong> Fiel Home</p>
              <p><strong>Adres:</strong> MAHMUDİYE MAH. ERTUĞRUL GAZİ CAD. NO: 46 A İNEGÖL/BURSA</p>
              <p><strong>Telefon:</strong> +90 552 229 90 07</p>
              <p><strong>E-posta:</strong> info@fielhome.com</p>
              <p><strong>Vergi Kimlik No:</strong> 7661111486</p>
              <p><strong>Vergi Dairesi:</strong> İnegöl</p>
            </div>
            
            <h2 className="text-xl font-semibold mb-4">2. SİTENİN KULLANIMI</h2>
            <p className="mb-4">
              Site üzerinden yapacağınız alışverişler ve diğer işlemler için 
              aşağıdaki kurallara uymanız gerekmektedir:
            </p>
            <ul className="list-disc list-inside mb-4 space-y-2">
              <li>18 yaş altı kullanıcılar veli izni ile siteyi kullanabilir</li>
              <li>Tüm bilgilerinizi doğru ve eksiksiz vermeniz gerekmektedir</li>
              <li>Site içeriğini kopyalayamaz, çoğaltamaz veya dağıtamazsınız</li>
              <li>Site güvenliğini tehlikeye atacak eylemler yapılamaz</li>
            </ul>
            
            <h2 className="text-xl font-semibold mb-4">3. SİPARİŞ VE ÖDEME</h2>
            <h3 className="text-lg font-semibold mb-3">3.1. Sipariş İşlemi</h3>
            <p className="mb-4">
              Sipariş verdiğinizde, ürün bilgileri ve fiyatlar güncel olarak 
              ekranda gösterilir. Sipariş onaylandıktan sonra değişiklik yapılamaz.
            </p>
            
            <h3 className="text-lg font-semibold mb-3">3.2. Fiyat ve Ödeme</h3>
            <ul className="list-disc list-inside mb-4 space-y-2">
              <li>Tüm fiyatlar Türk Lirası olarak gösterilir ve KDV dahildir</li>
              <li>Kredi kartı, banka kartı ve havale ile ödeme yapılabilir</li>
              <li>Ödeme güvenliği SSL sertifikası ile sağlanır</li>
              <li>Kampanyalı fiyatlar stok tükene kadar geçerlidir</li>
            </ul>
            
            <h2 className="text-xl font-semibold mb-4">4. TESLİMAT</h2>
            <p className="mb-4">
              Ürünleriniz aşağıdaki koşullarda teslim edilir:
            </p>
            <ul className="list-disc list-inside mb-4 space-y-2">
              <li>Teslimat süresi ürün özelliğine göre değişir</li>
              <li>Büyük mobilyalar için kurulum hizmeti sunulur</li>
              <li>Teslimat ücreti sepet tutarına göre belirlenir</li>
              <li>Ürün teslim alınmadığı takdirde kargo ücreti tahsil edilir</li>
            </ul>
            
            <h2 className="text-xl font-semibold mb-4">5. GARANTİ VE SORUMLULUK</h2>
            <h3 className="text-lg font-semibold mb-3">5.1. Ürün Garantisi</h3>
            <p className="mb-4">
              Tüm ürünler üretici garantisi ile satılır. Garanti süreleri 
              ürün özelliğine göre değişir ve ürün sayfasında belirtilir.
            </p>
            
            <h3 className="text-lg font-semibold mb-3">5.2. Sorumluluk Sınırları</h3>
            <p className="mb-4">
              Şirketimiz aşağıdaki durumlardan sorumlu değildir:
            </p>
            <ul className="list-disc list-inside mb-4 space-y-2">
              <li>Sistem arızalarından kaynaklanan gecikme ve zararlar</li>
              <li>Hatalı kullanımdan kaynaklanan ürün hasarları</li>
              <li>Üçüncü kişilerden kaynaklanan zararlar</li>
              <li>Mücbir sebeplerden kaynaklanan aksamalar</li>
            </ul>
            
            <h2 className="text-xl font-semibold mb-4">6. FİKRİ MÜLKİYET</h2>
            <p className="mb-4">
              Site içeriği (yazı, görsel, tasarım, logo, marka vb.) şirketimizin 
              fikri mülkiyetidir ve izinsiz kullanılamaz.
            </p>
            
            <h2 className="text-xl font-semibold mb-4">7. UYUŞMAZLIKLARIN ÇÖZÜMÜ</h2>
            <p className="mb-4">
              Bu koşullardan doğan uyuşmazlıklarda İnegöl Mahkemeleri ve 
              İcra Müdürlükleri yetkilidir.
            </p>
            
            <h2 className="text-xl font-semibold mb-4">8. DEĞİŞİKLİKLER</h2>
            <p className="mb-4">
              Şirketimiz bu koşulları önceden haber vermeksizin değiştirebilir. 
              Güncel koşullar sitede yayınlanır.
            </p>
            
            <p className="mt-8 text-sm text-gray-600">
              Bu koşullar {new Date().toLocaleDateString('tr-TR')} tarihinde güncellenmiştir.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TermsPage;
